<script setup>
useSeoMeta({
  title: 'Datenschutz',
});
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title tag="h1" class="text-wrap">Datenschutzerklärung</v-card-title>
          <v-card-text>
            <div class="text-body-1 mb-2">
              Schutz und Sicherheit Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Das
              Bundesministerium für Land- und Forstwirtschaft, Klima- und Umweltschutz, Regionen und
              Wasserwirtschaft (BMLUK) speichert und verarbeitet Daten daher ausschließlich im Sinne
              der Bestimmungen der Verordnung (EU) 2016/679 des Europäischen Parlaments und des
              Rates vom 27. April 2016 zum Schutz natürlicher Personen bei der Verarbeitung
              personenbezogener Daten, zum freien Datenverkehr und zur Aufhebung der Richtlinie
              95/46/EG (DSGVO) sowie des österreichischen Datenschutzgesetzes (DSG), BGBl. I Nr.
              165/1999 idgF.
            </div>
            <div class="text-body-1 mb-2">
              Diese Seite beschreibt, welche personenbezogenen Daten im Rahmen der Nutzung dieser
              Applikation in Übereinstimmung mit den gesetzlichen Bestimmungen verarbeitet werden,
              zu welchem Zweck dies geschieht, und welche Rechte Sie in Bezug auf Ihre Daten haben.
              Bei Fragen dazu wenden Sie sich bitte an
              <a href="mailto:service.entwaldung@bmluk.gv.at" class="text-primary"
                >service.entwaldung@bmluk.gv.at</a
              >.
            </div>
            <div class="text-body-1 mb-2">
              Bei der Bereitstellung dieser Applikation tritt das BMLUK als Bevollmächtigter im
              Sinne von Artikel 6 der Verordnung (EU) 2023/1115 (EUDR) auf, um im Namen des
              Marktteilnehmers die vereinfachte Erklärung gemäß Artikel 4a Absatz 2 an das in
              Artikel 33 genannte und von der EU-Kommission betriebene Informationssystem
              (TRACES-Datenbank) zu übermitteln. Die Datenschutzerklärung der EU-Kommission für die
              TRACES-Datenbank ist unter
              <a
                href="https://eudr.webcloud.ec.europa.eu/tracesnt/privacy-statement"
                target="_blank"
                class="text-primary"
                >https://eudr.webcloud.ec.europa.eu/tracesnt/privacy-statement</a
              >
              abrufbar. Die Nutzung dieser BMLUK-Applikation stellt eine Alternative zur
              unmittelbaren Abgabe der vereinfachten Erklärung im Informationssystem dar. Es handelt
              sich dabei um ein Service des BMLUK, das Ihnen kostenlos zur Verfügung gestellt wird
              und von Ihnen freiwillig genutzt werden kann und auf einer entsprechenden Einwilligung
              zur Datenverarbeitung beruht. Diese Einwilligung kann jederzeit per E-Mail an
              <a href="mailto:service.entwaldung@bmluk.gv.at" class="text-primary"
                >service.entwaldung@bmluk.gv.at</a
              >
              widerrufen werden. Vom BMLUK werden die im Rahmen der Nutzung dieser Applikation
              eingegebenen und übermittelten Inhaltsdaten für keine anderen Zwecke weiterverwendet.
              Bei Klicken der Schaltfläche „Bestätigen und übermitteln“ auf der Seite „Vereinfachte
              Erklärung“ werden Name und Adresse des Betriebes, der Identifikationstyp (GLN, UID
              oder Steuernummer) und die dazugehörige Nummer, sowie die für die vereinfachte
              Erklärung erfasste Lokalisierung (Postanschrift bzw. Flächen- und Punktdaten),
              Erzeugnisse, und deren Mengen an die TRACES-Datenbank übermittelt, da diese Angaben
              für die vereinfachte Erklärung verpflichtend sind. Die auf diese Weise übermittelten
              Daten werden von der EU-Kommission als Betreiberin der TRACES-Datenbank
              weiterverarbeitet.
            </div>
            <div class="text-body-1 mb-2">
              Damit Sie Ihre vereinfachten Erklärungen in dieser Applikation ansehen, drucken und
              weitergeben können, speichert das BMLUK eine Kopie der übermittelten Erzeugnisse,
              Mengen und Erzeugungsorte (Postanschrift bzw. Flächen- und Punktdaten). Die Kopie wird
              verschlüsselt und ohne direkte Verknüpfung mit Ihrem Benutzerkonto gespeichert; die
              Zuordnung zu Ihnen ist nur über die TRACES-Datenbank möglich. Sie wird fünf Jahre nach
              Übermittlung der vereinfachten Erklärung gelöscht, entsprechend der Aufbewahrungsfrist
              der Verordnung (EU) 2023/1115, oder früher, wenn die vereinfachte Erklärung in der
              TRACES-Datenbank nicht mehr als verfügbar geführt wird (etwa weil sie zurückgezogen
              wurde) oder Ihr Konto gelöscht wird.
            </div>
            <div class="text-body-1 mb-2">
              Enthält Ihre vereinfachte Erklärung Rinder, werden nach Vergabe der
              Identifikationsnummer Ihre Betriebsnummer (LFBIS), die Anzahl der Rinder sowie
              Identifikationsnummer, Prüfnummer und Datum der vereinfachten Erklärung an die
              Agrarmarkt Austria (AMA) übermittelt. Bis zur Übermittlung speichert das BMLUK
              Betriebsnummer und Anzahl der Rinder; danach werden sie gelöscht.
            </div>
            <div class="text-body-1 mb-2">
              Hinsichtlich der Zugangsdaten zu dieser Applikation gilt Folgendes, wenn Sie nicht
              über Ihren eAMA-Zugang einsteigen:
              <ul class="pl-4 mt-2">
                <li class="mb-1">
                  Bei Anmeldung mit ID Austria wird auf der Seite „Mein Konto“ unter „Angaben zum
                  Betrieb“ der Identifikationstyp (GLN, UID oder Steuernummer) sowie die
                  dazugehörige Nummer zum Zweck der Erstellung von vereinfachten Erklärungen
                  gespeichert.
                </li>
                <li class="mb-1">
                  Bei Anmeldung mit E-Mail werden auf der Seite „Mein Konto“ unter „Angaben zum
                  Betrieb“ die E-Mail-Adresse, Name, Adresse und Identifikationstyp (GLN, UID oder
                  Steuernummer) sowie die dazugehörige Nummer zum Zweck der Erstellung und
                  Verwaltung von vereinfachten Erklärungen gespeichert.
                </li>
              </ul>
            </div>
            <div class="text-body-1 mb-2">
              Unabhängig von der Art der Anmeldung können Sie Ihr Konto jederzeit auf der Seite
              „Mein Konto“ löschen. Ist das nicht möglich, können Sie die Löschung durch formlose
              Mitteilung an
              <a href="mailto:service.entwaldung@bmluk.gv.at" class="text-primary"
                >service.entwaldung@bmluk.gv.at</a
              >
              beantragen. Geben Sie dabei bitte die Identifikationsnummer einer Ihrer vereinfachten
              Erklärungen an. Bei der Löschung werden Ihre vom BMLUK gespeicherten Angaben zum
              Betrieb und die gespeicherten Kopien Ihrer vereinfachten Erklärungen gelöscht. Die in
              der TRACES-Datenbank gespeicherten vereinfachten Erklärungen bleiben davon unberührt
              und werden nach erneuter Anmeldung mit derselben Anmeldeart wieder angezeigt,
              allerdings ohne die gelöschten Kopien. Ebenfalls unberührt bleibt die Übermittlung von
              Rinderzahlen an die AMA. Ansonsten bleiben Ihre Zugangsdaten gespeichert, solange Ihr
              Konto aktiv ist. Konten, mit denen Sie sich fünf Jahre lang nicht angemeldet haben,
              werden automatisch gelöscht.
            </div>
            <div class="text-body-1 mb-2">
              Bei Klicken der Schaltfläche „Bestätigen und übermitteln“ auf der Seite „Vereinfachte
              Erklärung“ wird zum Zweck der Verknüpfung mit dieser Applikation ein aus Ihrer
              Benutzer-ID (LFBIS-Nummer bei eAMA Login, KUR bei USP Login, bPK bei ID Austria Login,
              E-Mail-Adresse bei E-Mail Login) errechneter, nicht umkehrbarer Hash-Wert als interne
              Referenz an die TRACES-Datenbank übermittelt.
            </div>
            <div class="text-body-1 mb-2">
              Zur Auswertung und Verbesserung dieser Applikation speichert das BMLUK anonyme
              Nutzungsstatistiken, etwa aufgerufene Seiten, Browser, Gerätetyp und Land. Dabei
              werden keine Cookies gesetzt und keine IP-Adressen gespeichert.
            </div>
            <div class="text-body-1 mb-2">
              Sie haben das Recht auf Auskunft über die Sie betreffenden personenbezogenen Daten
              sowie auf Berichtigung oder Löschung oder auf Einschränkung der Verarbeitung oder auf
              Widerspruch gegen die Verarbeitung sowie das Recht auf Datenübertragbarkeit. Wenn Sie
              der Auffassung sind, dass Ihren Rechten nicht oder nicht ausreichend nachgekommen
              wird, haben Sie die Möglichkeit einer Beschwerde bei der Aufsichtsbehörde (in
              Österreich ist dies die Österreichische Datenschutzbehörde:
              <a href="https://www.dsb.gv.at" class="text-primary">www.dsb.gv.at</a>).
            </div>

            <h2 class="text-h6 mt-4 mb-2">Verantwortlicher für die Datenverarbeitung</h2>
            <div class="text-body-1 mb-2">
              Bundesministerium für Land- und Forstwirtschaft, Klima- und Umweltschutz, Regionen und
              Wasserwirtschaft<br />
              Stubenring 1, 1010 Wien<br />
              E-Mail-Adresse:
              <a href="mailto:service.entwaldung@bmluk.gv.at" class="text-primary"
                >service.entwaldung@bmluk.gv.at</a
              >
            </div>

            <h2 class="text-h6 mt-4 mb-2">Datenschutzbeauftragter</h2>
            <div class="text-body-1 mb-2">
              Den Datenschutzbeauftragten des Bundesministeriums erreichen Sie unter:
            </div>
            <div class="text-body-1 mb-2">
              Stubenring 1, 1010 Wien<br />
              E-Mail-Adresse:
              <a href="mailto:datenschutzbeauftragter@bmluk.gv.at" class="text-primary"
                >datenschutzbeauftragter@bmluk.gv.at</a
              >
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
